<template>
  <div v-if="comment" class="created-comment">
    <div class="comment-label">{{ $t('timeSheet.labels.comment') }}</div>
    <div class="comment-value">{{ comment }}</div>
  </div>
</template>

<script>
export default {
  name: 'CreatedComment',
  props: {
    comment: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../styles/colors.scss';
@import '../styles/variables.scss';

.created-comment {
  padding: 34px $details-padding;
  background-color: $accent-blue;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: -0.16px;
  line-height: 19px;

  .comment-label {
    display: inline-block;
    text-transform: uppercase;
    color: $text-color-dark-2;
    margin-right: 1em;
  }
  .comment-value {
    display: inline-block;
  }
}

@media print {
  .created-comment {
    background: transparent;
    padding: 0;
    font-size: 11pt;
    margin-bottom: 5px;

    .comment-label {
      margin-right: 5px;
    }
  }
}

@media only screen and (max-width: 768px) {
  * {
    font-size: 0.8rem;
  }
  .created-comment {
    padding: $responsive-details-padding;
    .comment-label {
      display: block;
    }
  }
}
</style>
